import SonnerToast from '#lib/common/Presentation/Toast/SonnerToast.js';

export const Toaster = () => {
	return new SonnerToast();
};
